import Backbone from "backbone"
//require("backbone.nativeview")

export class BaseView extends Backbone.View{
    constructor(options) {
        super(...arguments);
    }

    addEvents(events){
        this.delegateEvents(_.extend(_.clone(this.events), events));
    }

    get isHOS(){
        return !!document.querySelector('.js-hos');
    }
}
